import React from 'react'
import {ICopierRow} from '../../../../apis/copier/copiers'
import TableLayout from '../../../../components/table/TableLayout'
import TableItem from '../../../../components/table/TableItem'
import Text from '../../../../components/text/Text'
import {useImage} from '../../../../utils/image'
import {useColor, useTag} from '../../../../utils/etc'
import {useTime} from '../../../../utils/time'
import {useDisplayNumber} from '../../../../utils/number'
import useNavigation from '../../../../hooks/useNavigation'
import useQueryExchanges from '../../../../hooks/etc/useQueryExchanges'
import WizImage from '../../../../components/image/WizImage'
import ic_arrow_right from '../../../../assets/images/ic_arrow_right.png'

interface IProps {
    className?: string
    data?: ICopierRow[]
}

const CopiersTable: React.FC<IProps> = ({className, data}) => {
    const {renderThumbnail} = useImage()
    const {getNumberColor} = useColor()
    const {localTimeString} = useTime()
    const {floorBalance, renderPercent} = useDisplayNumber()
    const {renderStateColor} = useTag()
    const {goCopierDetail} = useNavigation()

    const {data: exchangeData} = useQueryExchanges()

    return (
        <div className={`${className}`}>
            <TableLayout>
                {data?.map((copier, idx) => (
                    <TableItem
                        key={`${copier?.id}-${idx}`}
                        className={
                            'grid-cols-[320px_1fr_1fr_1fr_1fr_1fr] gap-x-[10px] gap-y-[25px] md:grid-cols-3 items-center md:items-baseline'
                        }
                        onClick={() => goCopierDetail(copier?.id)}>
                        <div className={'flex items-center gap-[30px] justify-center md:col-span-3'}>
                            <div className={'flex items-center gap-x-[5px]'}>
                                <div className={'space-y-[5px] '}>
                                    <Text className={'text-sub_blue text-ti3 text-center'}>Copier</Text>
                                    <WizImage
                                        src={renderThumbnail(copier?.user_thumbnail)}
                                        className={'w-[32px] h-[32px] rounded-full mx-auto'}
                                    />
                                    <div className={'flex items-center justify-between flex-1  pt-[5px]'}>
                                        <Text className={'text-ti2 w-[140px] text-center break-all'}>
                                            {copier?.user_name}
                                        </Text>
                                    </div>
                                </div>
                                <WizImage src={ic_arrow_right} className={'w-[10px]'} />
                                <div className={'space-y-[5px]truncate'}>
                                    <Text className={'text-font_leader text-ti3 text-center'}>Leader</Text>
                                    <WizImage
                                        src={renderThumbnail(copier?.leader_thumbnail)}
                                        className={'w-[32px] h-[32px] rounded-full flex-none mx-auto'}
                                    />
                                    <div className={'truncate pt-[5px]'}>
                                        <Text className={'truncate text-ti2 w-[140px] text-center break-all'}>
                                            {copier?.leader_name ? copier?.leader_name : '[No Leader Name]'}
                                        </Text>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-ti3 text-font03 text-center'}>Exchange</Text>
                            <div className={'flex items-center space-x-[10px] justify-center sm:flex-col sm:space-x-0'}>
                                <WizImage
                                    src={exchangeData?.find(list => list?.name === copier?.exchange)?.icon}
                                    className={'w-[20px]'}
                                />
                                <Text className={'sm:hidden'}>
                                    {exchangeData?.find(list => list?.name === copier?.exchange)?.display_name}
                                </Text>
                            </div>
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-ti3 text-font03 text-center'}>Profit</Text>
                            <div>
                                <Text
                                    className={`${getNumberColor(
                                        copier?.bot_score?.earning,
                                    )} text-ti2 text-center sm:text-ti3`}>
                                    {floorBalance(copier?.bot_score?.earning)}
                                </Text>
                                <Text className={`${getNumberColor(copier?.bot_score?.score)} text-ti3 text-center`}>
                                    ({renderPercent(copier?.bot_score?.score)})
                                </Text>
                            </div>
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-ti3 text-font03 text-center'}>Balance</Text>
                            <Text className={'text-ti1 text-center sm:text-ti3'}>
                                {floorBalance(copier?.current_balance)}
                            </Text>
                        </div>
                        <div className={'space-y-[5px]'}>
                            <Text className={'text-ti3 text-font03 text-center'}>Start At</Text>
                            <div>
                                <Text className={'text-body3 text-font03 text-center'}>
                                    {localTimeString(copier?.start_at)}
                                </Text>
                            </div>
                            {copier?.pause_at && (
                                <div className={'space-y-[5px]'}>
                                    <Text className={'text-body3 text-font_red text-center'}>
                                        Paused: {new Date(copier?.pause_at).toLocaleString()}
                                    </Text>
                                </div>
                            )}
                        </div>

                        <div className={'space-y-[5px]'}>
                            <Text className={'text-ti3 text-font03 text-center'}>Status</Text>
                            <div className={`${renderStateColor(copier?.status === 'running')} mx-auto`}>
                                {copier?.status}
                            </div>
                        </div>
                    </TableItem>
                ))}
            </TableLayout>
        </div>
    )
}

export default CopiersTable
